var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.52,
    height: 21.768,
    viewBox: "0 0 23.52 21.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M23.363,5.427a7.172,7.172,0,0,0-9.6-.785A7.162,7.162,0,0,0,3.774,5.8a7.939,7.939,0,0,0,.393,10.479l7.3,7.633a3.174,3.174,0,0,0,4.587,0l7.3-7.633A7.933,7.933,0,0,0,23.363,5.427ZM21.7,14.582,14.4,22.2a.868.868,0,0,1-1.27,0l-7.3-7.658a5.429,5.429,0,0,1,0-7.363,4.876,4.876,0,0,1,7.058,0,1.142,1.142,0,0,0,1.67,0,4.876,4.876,0,0,1,7.058,0,5.429,5.429,0,0,1,.094,7.363Z",
    transform: "translate(-1.988 -3.121)",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackheart);
export default __webpack_public_path__ + "static/media/blackheart.db6572ef78da2902fb4ac0a71f5fe3fa.svg";
export { ForwardRef as ReactComponent };